import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en.json";
import fr from "@/locales/fr.json";
import de from "@/locales/de.json";
import es from "@/locales/es.json";

export const SUPPORTED_LOCALES = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "es", label: "Español", short: "ES" },
];

const SUPPORTED_CODES = SUPPORTED_LOCALES.map((l) => l.code);
const STORAGE_KEY = "erio_locale";

/**
 * Resolve the locale to boot the React app with, honouring the
 * precedence chain agreed for iter156:
 *
 *   URL prefix (/fr/…)  >  user preference (localStorage)
 *                       >  tenant default locale (set by App.jsx after /me)
 *                       >  navigator.language
 *                       >  English
 */
export function resolveBootLocale() {
  // 1. URL prefix
  try {
    const first = (window.location.pathname || "").split("/").filter(Boolean)[0];
    if (first && SUPPORTED_CODES.includes(first)) return first;
  } catch { /* SSR / private-mode safety */ }

  // 2. Explicit user preference
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_CODES.includes(stored)) return stored;
  } catch { /* private mode */ }

  // 3. Browser default — match by primary subtag only ("fr-CA" → "fr").
  try {
    const nav = (navigator.language || "").toLowerCase().split("-")[0];
    if (nav && SUPPORTED_CODES.includes(nav)) return nav;
  } catch { /* SSR */ }

  return "en";
}

/** Persist a user-chosen locale so it survives reloads. */
export function persistLocale(code) {
  if (!SUPPORTED_CODES.includes(code)) return;
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* private mode */ }
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    de: { translation: de },
    es: { translation: es },
  },
  lng: resolveBootLocale(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
